import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { HoraMeridianaPipe } from './../../pipes/hora-meridiana.pipe';
import { TipoVisitaNombrePipe } from 'src/app/pipes/tipo-visita-nombre.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MenuComponent } from './menu/menu.component';
import { ToastInformativoComponent } from './toast-informativo/toast-informativo.component';
import { BarraPaginacionComponent } from './barra-paginacion/barra-paginacion.component';
import { GrupoBotonesComponent } from './grupo-botones/grupo-botones.component';
import { BotonesCambiosComponent } from './botones-cambios/botones-cambios.component';
import { TablaGeneralComponent } from './tabla-general/tabla-general.component';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { ComponentesCompartidosRoutingModule } from './componentes-compartidos-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { DialogoPagosComponent } from './dialogo-pagos/dialogo-pagos.component';
import { BuscarComponent } from './buscar/buscar.component';
import { CalendarioMesComponent } from './calendario-mes/calendario-mes.component';
import { FiltroFechaComponent } from './filtro-fecha/filtro-fecha.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { SelectIndicativoComponent } from './select-indicativo/select-indicativo.component';
import { GrupoFamiliarComponent } from './grupo-familiar/grupo-familiar.component';
import { GrupoFamiliarTitularesComponent } from './grupo-familiar-titulares/grupo-familiar-titulares.component';

@NgModule({
  declarations: [
    MenuComponent,
    ToastInformativoComponent,
    BarraPaginacionComponent,
    GrupoBotonesComponent,
    BotonesCambiosComponent,
    TablaGeneralComponent,
    HeaderComponent,
    DialogoPagosComponent,
    HoraMeridianaPipe,
    BuscarComponent,
    CalendarioMesComponent,
    FiltroFechaComponent,
    SelectIndicativoComponent,
    GrupoFamiliarComponent,
    GrupoFamiliarTitularesComponent,
    TipoVisitaNombrePipe
  ],
  exports: [
    MenuComponent,
    ToastInformativoComponent,
    GrupoBotonesComponent,
    BotonesCambiosComponent,
    TablaGeneralComponent,
    HeaderComponent,
    HoraMeridianaPipe,
    BuscarComponent,
    CalendarioMesComponent,
    SelectIndicativoComponent,
    GrupoFamiliarComponent,
    GrupoFamiliarTitularesComponent,
    TipoVisitaNombrePipe
  ],
  imports: [
    MatSelectModule,
    MatProgressSpinnerModule,
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatMenuModule,
    ComponentesCompartidosRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatCheckboxModule
  ]
})
export class ComponentesCompartidosModule { }
